module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-hong-kong-ctb01-01@w.438581d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-hong-kong-ctb01-01@w.png
// module id = kd6x
// module chunks = 0